import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { countriesCodes } from 'helpers/usStates';
import { editDepositPaymentByIdApi } from 'api';
import {
  Button,
  Grid,
  Icon,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';


const EditDepositPayment = () => {
  const dispatch = useDispatch();
  const { entity_id } = useParams<{ entity_id: string }>();
  const { editableDepositPayment } = useSelector((state: IReduxState) => state.deposits);

  const {
    active_credit_card_id,
    credit_cards,
    address: {
      city,
      country_id,
      email,
      firstname,
      lastname,
      postcode,
      region,
      telephone,
      street = []
    }
  } = editableDepositPayment;

  const [paymentAccount, setPaymentAccount] = useState(active_credit_card_id);

  const handleChangePaymentCard = (e) => {
    setPaymentAccount(e.target.value);
  };

  const handleSavePaymentCard = () => {
    const payment = {
      depositId: entity_id,
      creditCardId: paymentAccount,
    };
    editDepositPaymentByIdApi({ dispatch, payment });
  };

  return (
    <div className="py-6 px-2 mt-4">
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography className="mb-4">
            This payment record will be used for future payments. Any changes will take effect on the next billing.
          </Typography>
          <Typography className="mb-2" variant="h6">
            Payment Account
          </Typography>
          <Select
            fullWidth
            variant="outlined"
            name="frequency_unit"
            required
            className="mb-2 max-w-300"
            value={paymentAccount}
            onChange={(e) => handleChangePaymentCard(e)}
          >
            {credit_cards?.map((el) => (
              <MenuItem key={el.credit_card_id} value={el.credit_card_id}>
                {el.credit_card}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography className="mb-2" variant="h6">
            Billing Address Information
          </Typography>
          <div className="ml-2 mb-2">
            <Grid item xs={12}>
              <Typography>
                {`${firstname} ${lastname}`}
              </Typography>
            </Grid>

            {street.map((str, index) => (
              <Grid item xs={12} key={index}>
                <Typography>
                  {str}
                </Typography>
              </Grid>
            ))}
            <Grid item xs={12}>
              <Typography>
                {`${city}, ${region} ${postcode}`}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                {countriesCodes[country_id]}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <div className="flex">
                <Icon className="mr-2" fontSize="small">phone</Icon>
                <div>
                  <Typography className="text-primary">
                    <a href={`tel:${telephone}`}>{telephone}</a>
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex">
                <Icon className="mr-2" fontSize="small">email</Icon>
                <div>
                  <Typography className="text-primary">
                    <a href={`mailto:${email}`}>{email}</a>
                  </Typography>
                </div>
              </div>
            </Grid>
            <Typography className="mt-2 text-13 text-light-gray">
              {`Address corresponding to ${credit_cards?.find((card) => card.credit_card_id === active_credit_card_id)?.credit_card}.`}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className="mt-4"
        onClick={handleSavePaymentCard}
      >
        Save
      </Button>
    </div>
  );
};

export default EditDepositPayment;
